<div class="signaalkaart-header">
  <div class="titel">
    <div class="mat-subtitle-1">{{signaalkaart.getTitel()}}</div>
    <div>{{signaalkaart.getCategorie()}}</div>
  </div>
  <div>
    @if (client) {
      <span class="mat-subtitle-1">{{client.getNaam()}}</span>
    }
    @if (client) {
      <span> ({{client.getNummer()}})</span>
    }
  </div>
</div>
